import loadable from '@loadable/component';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const BuyCreditsLinksLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "BuyCreditsLinks" */
      './BuyCreditsLinks.dynamic'
    ),
  { fallback: <LoadingPageLoadable /> },
);
